import { render, staticRenderFns } from "./CookieNotification.vue?vue&type=template&id=3d9b5ac2&scoped=true&"
import script from "./CookieNotification.vue?vue&type=script&lang=js&"
export * from "./CookieNotification.vue?vue&type=script&lang=js&"
import style0 from "./CookieNotification.vue?vue&type=style&index=0&id=3d9b5ac2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d9b5ac2",
  null
  
)

export default component.exports